<template>
  <div class="nav-item" :style="cssProps">
    <fa class="icon" :icon="icon" />
    <!-- <p> -->
    {{ text }}
    <!-- </p> -->
  </div>
</template>

<script>
export default {
  name: "NavItem",
  props: {
    text: { type: String, default: "nav-item" },
    icon: {
      type: String,
      default: "code",
    },
  },
  computed: {
    cssProps() {
      let display = "block";
      if (this.icon == null || this.icon == "code") {
        display = "none";
      }

      return {
        "--icon-display": display,
      };
    },
  },
};
</script>

<style>
.nav-item {
  height: 100%;
  width: max-content;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  /* background: var(--light-clr); */
  color: var(--dark-clr);
  padding: 0 1rem;
  transition: var(--transition);
  gap: var(--gap);
}
.icon {
  transition: var(--transition);
  aspect-ratio: 1;
  color: var(--dark-clr);
  display: var(--icon-display);
}
.nav-item .icon,
.nav-item p {
  margin: 0 0.2rem 0 0.2rem;
  width: max-content;
}

.nav-item:hover,
.nav-item:focus {
  --dark-clr: var(--mid-dark-clr);
}

@media screen and (max-width: 30rem) {
  .nav-item {
    width: 100%;
    /* min-height: max-content; */
    height: 100%;
    margin-inline: 0;
    padding: 1rem 0.5rem;
    padding: 1.2rem 0.5rem;
    flex-direction: row-reverse;
    justify-content: flex-start;
    overflow: hidden;
  }
}

@media screen and (max-width: 46rem) {
  .nav-item {
    width: 100%;
    /* min-height: max-content; */
    height: 100%;
    margin-inline: 0;
    padding: 1rem 0.5rem;
    padding: 1.2rem 0.5rem;
    flex-direction: row-reverse;
    justify-content: flex-start;
    overflow: hidden;
  }
}
</style>
